import apiClient from '../api';


export const getUserData = async () => {
   const token = await localStorage.getItem('token');
   console.log({token})
  try {
    const token = await localStorage.getItem('token');

    if (!token) return console.log("No token found");

    const response = await apiClient.get(`gestock/user/profile`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    console.log({response})
    return response.data;

  } catch (error) {
    console.log({error})
    throw error.response?.data || error.message;
  }
};